
import { defineStore } from 'pinia'

export const usePartnersStore = defineStore('partnersStore', {
  state: () => ({
    partners: [
      { name: "Casas Bahia", alias: "casas-bahia", id: 3, chave: "casas_bahia" },
      { name: "Digio", alias: "digio", id: 1, chave: "digio" },
      { name: "Ponto Frio", alias: "pontofrio", id: 2, chave: "pontofrio" },
    ] as Array<CreditorProfile>
  }),

  getters: {
    getPartners: (state) => state.partners,
  },
})

